// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function Avatar(props) {
  let __size = props.size;
  let __src = props.src;
  let name = props.name;
  let src = __src !== undefined ? __src : AvatarSrcUrl.placeholder;
  let size = __size !== undefined ? __size : 2;
  return JsxRuntime.jsx("img", {
    className: TailwindMerge.twMerge([
      "flex-shrink-0 block rounded-full object-cover",
      size === 1 ? "w-10 h-10" : (
          size === 2 ? "w-[50px] h-[50px]" : (
              size === 3 ? "w-[60px] h-[60px]" : (
                  size === 4 ? "w-[70px] h-[70px]" : (
                      size === 5 ? "w-[90px] h-[90px]" : "w-6 h-6"
                    )
                )
            )
        )
    ]),
    title: name,
    alt: name,
    src: src,
    onClick: props.onClick
  });
}

let make = Avatar;

exports.make = make;
/* AvatarSrcUrl Not a pure module */
